import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faAngleDoubleLeft,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Link } from "react-router-dom";
import { Table, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "jalali-moment";

const MySwal = withReactContent(Swal);

export default class CommentTable extends Component {
  constructor() {
    super();
    this.state = {
      posts: [],
    };
    this.getPost();
  }

  count = 0;

  render() {
    return (
      <div className="index">
        {this.state.posts.length > 0 ? (
          <div className="table">
            <Table striped bordered responsive>
              <thead>
                <tr>
                  <td>#</td>
                  <th>عنوان مطلب</th>
                  <th>کامنت</th>
                  <th>وضعیت</th>
                  <th>تاریخ</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {this.state.posts
                  .reverse()
                  .map((item, i) => this.renderItem(item, i))}
              </tbody>
            </Table>
          </div>
        ) : (
          <Spinner animation="border" variant="primary" />
        )}
      </div>
    );
  }

  renderItem(item, i) {
    return (
      <tr key={item._id}>
        <td>{i}</td>
        <td>{item.post.title}</td>
        <td style={{ width: "40%" }}>{item.comment}</td>
        <td>
          {item.flag == 1
            ? "تایید شده"
            : item.flag == 0
            ? "در انتظار تایید"
            : "رد شده"}
        </td>
        <td>
          {moment(item.created_at, "YYYY/MM/DD")
            .locale("fa")
            .format("YYYY/MM/DD")}
        </td>
        <button className="danger" onClick={() => this.deletePost(item._id)}>
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </tr>
    );
  }

  getPost() {
    axios
      .get("https://arianaapp.arianaapply.com/panel/get-all-comment")
      .then((response) => {
        this.setState({ posts: response.data });
      })
      .catch((err) => {
        console.log(err);

        MySwal.fire({
          title: "دوباره امتحان کنید",
          icon: "error",
        });
      });
  }

  deletePost(id) {
    MySwal.fire({
      title: "مطمئنید؟",
      text: "در صورت حذف امکان بازگشت وجود ندارد",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله, پاکش کن!",
      cancelButtonText: "نه بیخیال",
    }).then((result) => {
      if (result.value) {
        axios
          .post(`https://arianaapp.arianaapply.com/panel/delete-comment`, {
            id: id,
          })
          .then((response) => {
            Swal.fire("حذف شد!", "عملیات شما با موفقیت انجام شد", "success");
          })
          .catch((err) => {
            console.log(err);
            MySwal.fire({
              title: "دوباره امتحان کنید",
              icon: "error",
            });
          });
      }
    });
  }

  answers(id) {
    Swal.fire({
      title: "جواب کامنت",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Look up",
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        axios
          .post("https://arianaapp.arianaapply.com/panel/comment-answer", {
            id: id,
            reply: login,
          })
          .then(() => {
            Swal.fire("انجام شد!", "عملیات شما با موفقیت انجام شد", "success");
          })
          .catch((err) => {
            console.log(err);
            MySwal.fire({
              title: "دوباره امتحان کنید",
              icon: "error",
            });
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((res) => {
      if (res.value) {
        Swal.fire("انجام شد!", "عملیات شما با موفقیت انجام شد", "success");
      }
    });
  }
}
